"use strict";

var _require = require("../data/index"),
    countries = _require.countries;

function findFlagUrlByPredicate(countryInfos, predicate) {
	var countryInfo = countryInfos.find(predicate) || { flag: "" };

	return countryInfo.flag;
}

module.exports = {
	findFlagUrlByCountryName: function findFlagUrlByCountryName(countryName) {
		var flagUrl = findFlagUrlByPredicate(countries, function (_ref) {
			var name = _ref.name;
			return name.toUpperCase() === countryName.toUpperCase();
		}) || findFlagUrlByPredicate(countries, function (_ref2) {
			var altSpellings = _ref2.altSpellings;
			return altSpellings && altSpellings.some(function (item) {
				return item.toUpperCase() === countryName.toUpperCase();
			});
		});

		return flagUrl;
	},
	findFlagUrlByNationality: function findFlagUrlByNationality(nationality) {
		return findFlagUrlByPredicate(countries, function (_ref3) {
			var demonym = _ref3.demonym;
			return demonym.toUpperCase() === nationality.toUpperCase();
		});
	},
	findFlagUrlByIso2Code: function findFlagUrlByIso2Code(iso2Code) {
		return findFlagUrlByPredicate(countries, function (_ref4) {
			var iso2 = _ref4.iso2;
			return iso2.toUpperCase() === iso2Code.toUpperCase();
		});
	},
	findFlagUrlByIso3Code: function findFlagUrlByIso3Code(iso3Code) {
		return findFlagUrlByPredicate(countries, function (_ref5) {
			var iso3 = _ref5.iso3;
			return iso3.toUpperCase() === iso3Code.toUpperCase();
		});
	}
};